export default {
    welcome: "welcome to Smartee.cn !",
    login: "Login",
    help: "HELP",
    register: "Registration",
    registerSuccess: "registered",
    changePasswordSuccess: "password changed",
    loginTitle: "logining page",
    registerTitle: "Registration page",
    mine: "Mine",
    username: "Account",
    password: "Password",
    forget: "Forget password",
    phoneNumber: "phone number",
    inputCount: "username/phone number",
    mobile: "Please enter your mobile phone number/email address",
    refCode: "Get verification code/ to get verification code",
    code: "Verification code",
    inputPassword: "Please enter your password",
    inputConformPassword: "Please enter your password again",
    passwordlg6: "Password should be at least 6 characters long!",
    hascount: "Existing account",
    agreeIt: 'Please check "Agree to Smartee User Registration Agreement"',
    verifynotise: "Please fill in the verification code",
    passwordSame: "The passwords you entered twice must be consistent",
    passwordDiff: "The passwords you entered do not match!",
    agree: "Agree to Smartee User Registration Agreement",
    acount: "Login name",
    surname: "Surname",
    name: "First name",
    sex: "Gender",
    male: "Male",
    female: "Female",
    expand: "expand",
    savesuccess: "already saved",
    pleaseenteryourage: "please enter your age",
    selectaddress: "please fill in / choose your consignee address",
    collapse: "pack up",
    incorrectage: "an error age ",
    selecthospitalname: "please choose the hospital or clinic",
    enterlastgender: "please input the gender",
    pleasetypeyourname: "please enter name",
    pleasetypeyourphone: "please enter phone number",
    phonerror: "error phone number, please check",
    filter: "select",
    email: "Email",
    medicalInstitution: "Hospital or clinic",
    selectyouarea: "please check in the region/ area",
    selectyouareadetail:
        "please specify the specific district when filling in the address",
    zipCode: "post code",
    hospitalAddress: "address of the hospital or clinic",
    finish: "finish/ finished",
    save: "submit/ submission",
    cancel: "Cancel",
    deletesuccess: "deleted",
    isAuthentication: "licenced",
    unAuthentication: "unlicenced / not licenced yet",
    enterusername: "please fill in the user name",
    filltheusergender: "please fill in the user gender",
    agevalue: "age must be a numeric value",
    care: "Followed ",
    uncare: "cancel follow",
    hadcare: "already followed",
    undone: "To be processed",
    unsubmit: "To be submitted",
    sendtheverificationcode: "send verification code",
    passwordupdated: "password changed",
    done: "In Treatment",
    resend: "resend 10 seconds later",
    resendcode: "resend verification code",
    oldphonerules: "former phone number can't be left out",
    newphonerules: "new phone number can't be left out",
    newphonesuccess: "phone number changed",
    newphoneerror: "phone number unchanged",
    finished: "Finished",
    addPatient: "Add a patient",
    patientName: "Patient name",
    patientgender: "patient gender",
    patientNameRequired: 'unsaved, patient name required in the "basic info"',
    patientNameMsg: 'please fill with the patient name in the "basic info"',
    hospitalNameMsg: 'please fill with the clinic name in the "basic info"',
    addressMsg: 'please fill with the consignee address in the "basic info"',
    SeriesMsg: 'please fill with the patient name in the "basic info"',
    angleMsg:
        "please choose the Angle's classification in the malocclusion type column",
    mismatchMsg:
        'please choose the malocclusion classification in the "malocclusion type column"',
    cashphotoMsg:
        'please upload necessary facial and intraoral photos in the "Photos message"',
    casesumbit1Msg:
        'please fill with patient requirements in the "patient form"',
    casesumbit2Msg: 'please fill with treatment goal in the "patient form"',
    casesumbit3Msg:
        'Please choose occlusion correcttion information in the "patient form"',
    casesumbit8Msg:
        'Please choose facial sagittal relationship information in the "patient form"',
    casesumbit14Msg:
        'please fill with patient median line situation in the "patient form"',
    casesumbit15Msg:
        'Please choose  spacing correcttion information in the "patient form"',
    casesumbit16Msg:
        'Please choose crowding correcttion information in the "patient form"',
    toothmodelMsg: "please fill in the tooth model info",
    modelMsg: 'please upload the digital model file in the "local file"',
    designdataMsg: "designdataMsg",
    scanMsg: "scanning confirmed completed !",
    patient: "Name",
    productLine: "Treatment Type",
    createTime: "Date of creation",
    notiseTime: "noticing date",
    clinicalOperation: "Clinical operation",
    caseProgress: "Treatment Status",
    notyetselected: "product line not selected yet",
    sustainedstorage: "product line saved",
    allResult: "All results",
    yearold: "Age",
    qingkuang: "situation of inspection",
    mark: "mark",
    all: "All",
    features: "Features",
    orthodonticTreatment: "Orthodontic treatment plan",
    caseStatus: "case situation",
    submitsuccess: "submitted",
    enteraccount: "please fill in the user name",
    inputPatientName: "Please enter the patient's name",
    inputReceiveAddress: "please fill in the consignee address",
    inputdetailAddress: "please fill in the detailed address",
    namecantberepeat:
        "The name and address was already filled in the form, it can not be repeated.",
    scan: "Smartee-CareStream Scanning System",
    createsuccess: "added/ added already",
    givemelittletime: "more time needed",
    scaning: "be in scanning",
    zh: "Simplified Chinese",
    en: "English",
    es: 'Spanish',
    fr: 'French',
    screenfull: "Full screen",
    size: "Layout size",
    selecttoothmodel: "choose one type of tooth model at least",
    Pleaseselectfileupload: "please select files to be uploaded",
    dentalmodelsuspended: "tooth model already saved",
    uploadsuccess: "already uploaded",
    messageType: "Message type",
    messageContent: "Message content",
    messageStatic: "Message status",
    scanfile: "Intraoral scanning file",
    tooth: "Tooth arrangement",
    toothfile: "Tooth arrangement file",
    transferredcases: "Transferred cases",
    transfernewcases: "Transfer new cases",
    usescan: "Start Smartee Smartee-CareStream Scanning System",
    smarteeusescan: "Smartee Smartee-CareStream Scanning System",
    resmarteeusescan: "rescan",
    previewusescan: "checking scanning",
    scanfilesuccess: "scanning files uploaded",
    basemessage: "Basic Information",
    selectionLines: "Treatment Type",
    mismatch: "mismatch",
    mixfont: "occlusion",
    mismatchType: "Malocclusion type",
    photoUpload: "Photos",
    otherPhotos: "Other photos",
    xUpload: "X-ray",
    caseform: "Presciption",
    storage: "Save",
    next: "Next",
    last: "Previous",
    required: "infomation required",
    toothmodel: "tooth model",
    previewandsubmit: "Preview & submission",
    Malocclusiontype: "Patient Diagnosis",
    patientMessage: "Patient information",
    affiliatedHospital: "Affiliated clinic",
    contactNumber: "Phone number",
    receivingAddress: "Receiving address",
    smartee1: "Smartee GE",
    classicVersion: "Classic version",
    smartee2: "Smartee Pre+",
    prideEdition: "Pride edition",
    smartee3: "Smartee U+",
    youthVersion: "Youth version",
    angletype: "Angle classification",
    faceLeft: "Lateral Side",
    faceLateral: "Frontal",
    faceSmile: "Frontal Smile",
    upperDentition: "Upper Dentition",
    amplificationPhoto: "dblclick to delete Photos",
    lowerDentition: "Lower Dentition",
    rightImage: "Right Lateral Intraoral",
    intraoralImage: "Frontal Intraoral",
    leftImage: "Left Lateral Intraoral",
    // photosDel: 'Photos can be uploaded in batches and deleted by double-click',
    photosDel: "Batch upload photos, double click to delete",

    uploadPhotos: "Upload photos",
    enterPhotoLocation: "Please enter the Photos location information",
    title: "Personal information",
    phone: "Phone",
    telephone: "Landline",
    city: "City",
    quality: "Medical practitioner qualification certificate",
    addressmanagement: "Address management",
    setting: "Security setting",
    childcountsetting: "Subaccount setting",
    preferences: "Clinical preferences",
    multipointPhysician: "Multi-sited practices",
    IsCase: "Case Management",
    IsFinance: "Financial rights",
    casesStatistic: "Case statistics",
    remark: "remarks",
    refresh: "Refresh",
    close: "Close",
    closeOthers: "Close others",
    closeAll: "Close all",
    angle1: "Angle Class I",
    angle2: "Angle Class II",
    angle3: "Angle Class III",
    uncertain: "Uncertain",
    crowding: "Crowding",
    dentitionClearance: "Spacing",
    Protrusion: "Protrusion",
    openjaw: "Open Bite",
    anteriorCrossbites: "Anterior Crossbite",
    anterior: "Anterior teeth",
    rightTeeth: "Right posterior teeth",
    leftTeeth: "Left posterior teeth",
    posteriorCrossbite: "Posterior Crossbite",
    deepCoverage: "Deep Overjet",
    deepOverbites: "Correcting the deep overbite",
    other: "Other",
    writeinstructions: "please note in special remarks",
    surfaceFault: "Panoramic Radiography",
    lateralCranium: "Lateral Radiography",
    uploadCBCT: "Upload CBCT",
    uploadFiles: "Upload files",
    choseModelFiles: "Please select the digital model files",
    browse: "Browse",
    otherXray: "Upload other X-ray radiographs",
    inputOtherXray: "Please enter the X-ray radiograph location information",
    chiefComplaint: "Patient Concerns",
    addnotes: "remark column",
    unevenTeeth: "Crowding",
    siliconerubberstamp: "silicone rubber impression",
    diastema: "Spacing",
    dentalProtrusion: "Protrusion",
    dentofacialJaw: "Cross Bite",
    majorObjectives: "Main Objectives",
    arrangeTeeth: "Align teeth",
    closingDentitionSpace: "Closing Space",
    improvementProfile: "Improve the Protrusion",
    orthodonticTeeth: "Arch",
    orthodonticsDescribe:
        "The full-jaw silicone rubber impression or digital files should be submitted, even just for single-jaw correction",
    wholeJaw2: "Both Archs",
    maxillary: "Maxillary",
    mandible: "Mandibular",
    toothInformation: "Tooth information",
    toothnotise:
        "Missing teeth are in gray and deciduous teeth are in green. If choose deciduous teeth, then X- Rays is required.",
    noDeletion: "No teeth missing",
    noDeciduousTeeth: "No deciduous teeth",
    deciduousTeeth: "The following teeth are deciduous teeth",
    teethmiss: "The following teeth are missing",
    submitTeethModel: "Please submit the teeth model",
    faceShape: "Face Type",
    siliconeRubberModel: "Silicone rubber model",
    siliconeRubberImpression: "Silicone rubber impression",
    siliconeRubberRecord: "Silicone rubber occlusion record",
    courierCompany: "express company serial number",
    courier: "Courier number/ tracking number",
    refCn: "refCn",
    couriercompany: "express  company / courier service company",
    courierNumber: "please input your tracking number",
    seachCourier:
        "Enter the courier number and press Enter to query the express information, or click the button to query the express information",
    courierNotise:
        "In order to get the design animation and aligners faster, please be sure to include the case ID number when filling in the tracking number or mailing the model.",
    modelFiles: "Digital model files",
    localFile: "Local files",
    shape3: "3Shape/Sirona intraoral scanning data",
    notImg: "the file is not in image type ",
    wrongformat: "wrong image format",
    compressionerror: "unworkable compression format",
    upload: "Upload",
    uploading: "uploading....",
    uploadfailed: "uploading failed / mission failed",
    fileupload: "file uploading",
    mouthdata: "scanning data/ scanning file",
    mattersNeedingAttention: "Notes",
    includeScans:
        "Maxillary, mandible and occlusion scanning record must be included;",
    includeZip: "Upload as a zip (the file type must be .rar/.zip).",
    shape: "3Shape",
    shape3web: "Log in 3Shape website",
    loginsironaaccount: "login your Sirona account",
    shape3user: "Enter your 3Shape username and password",
    shape3qq:
        'Add Smartee’s account "48150554@qq.com" and send the data scanned by TRIOS to the account',
    oemnotise:
        'the designing data is only for OEM Service. You only need to fill in "basic information" and "product selection".',
    sinold: "Sirona intraoral scanning data",
    textareatip:
        'please limit to 1000 words for any other instructions(  you can use "ctrl +z" to undo the operation after deleting by mistake)',
    sinoldCount: "Log in to your Sirona account",
    addSmarteeCount:
        "Add Smartee’s account “Smartee” and send the scanned data to the account",
    sendEmail:
        'You can send zip, rar and stl files to kousao@smartee.cn. Please indicate "Institution name + doctor name + patient name" in the subject of the mail.',
    patientDetails: "Patient details",
    patientHome: "Patient home page",
    deliveryRequirements: "delivery requirements",
    oneTimeDelivery: "one-off delivery",
    phasedDelivery: "staged delivery",
    endTherapy: "treatment finished",
    lateHolderShipped: "The later-stage retainers have been shipped",
    expressType: "Type of express delivery",
    logisticsNumber: "Logistics number",
    lateStageDelivery: "Later-stage retainer delivery forecast",
    endTreatmentConfirmed: "Treatment termination confirmed",
    laterStageHolderProcessing: "Later-stage retainers in processing",
    estimatedDelivery: "Expected later-stage retainer delivery time",
    confirmationTreatment: "Confirmation of treatment end",
    see: "View",
    fineTuning: "Refinement",
    productionStage: "Production stage",
    delivery: "Delivery",
    firstStage: "First stage",
    appliancesShipped: "Aligner shipped",
    steps: "steps",
    oem: "OEM Service",
    ordernumber: "order number",
    maxillarySteps: "maxillary steps",
    mandibularSteps: " mandibular steps",
    totalMaxillarySteps: "Total maxillary steps",
    totalMandibularSteps: "Total mandibular steps",
    numberDeliverySteps: "Number of delivery steps",
    ShipmentForecast: "Shipment forecast",
    FineTuningDesignConfirmed: "Refined design confirmed",
    ProcessingFineTuned: "Refined aligner in processing",
    totalMaxillarySteps: "Total maxillary steps",
    finelyAdjustDeliveryTime: "Expected aligner delivery time",
    designPhase: "Design phase",
    processing: "refinement stage",
    postWarranty: "retainer",
    design3D: "3D design",
    unconfirm: "unconfirm",
    confirmed: "Confirmed",
    abandon: "cancel ",
    designSN: "designing serial number",
    designTime: "designing date",
    confirm: "Confirm",
    quotation: "Quotation",
    receivingInspection: "Receiving inspection",
    checkQualified: "Pass the inspection",
    unqualified: "Fail the inspection",
    modelReceived: "Model Received",
    fineTunedCasesSubmitted: "Refined cases submitted",
    fineTunedCasesTobeSubmit: "Refined cases to be submitted",
    fineTunedCasesStorage: "Temporary storage of refined programme",
    completeInformation:
        "The information needs to be completed. Please complete it",
    rearrangingTeeth: "Realign teeth",
    ViewTooth: "View tooth alignment",
    followUpConfirmed: "Follow-up processing application confirmed",
    followUpApplication: "Follow-up processing applied for",
    followUptoComform: "Follow-up processing to be confirmed",
    followUpTime: "Expected aligner follow-up processing time",
    residualAppliance: "Residual aligners",
    vice: "set/ piece ",
    backPatiant: "back to patient situation page",
    designConfirmed: "Design animation confirmed",
    clinicalDoctorsModifications:
        "Clinicians propose the suggestions on revision",
    tobeConfirmed: "To be confirmed",
    casesSubmitted: "Cases submitted",
    casesTobeSubmit: "Cases to be submitted",
    impactData: "Image data",
    group: "Group",
    caseInformation: "Case information",
    proceduresStage: "This stage",
    proceduresStage1: "step requires clinical operation",
    proceduresNotStage: "no clinical operation at this stage",
    fineAdjustment: "refinements",
    processingFollowUp: "Follow-up processing",
    finelyTunedCaseSubmissionForm: "Refined case submission form",
    currentAppliancesFit: "Fitting status of current aligner",
    applianceFit: "Fitting of aligner",
    judgementBasis: "Judgment criteria",
    appliancesUnfit: "Aligner unfit",
    needmodelfile:
        "Full-mouth silicone rubber impression or full-mouth digital model files should be submitted.",
    defaultGrind:
        "Please grind all intraoral accessories before taking the silicone rubber; if not, our company will regard them as being ground by default.",
    clinicalExamination: "Clinical examination",
    orthodonticSteps:
        "The number of steps to wear the aligner in this feedback is",
    isDentitionSpace: "Is there dentition space",
    none: "No",
    have: "Yes",
    left: "Left",
    right: "Right",
    clearanceCheck:
        "Check the current Spacing (please measure accurately with the clearance gauge)",
    otherCheck:
        "Other examinations (including tooth dislocation, mobility and early contact etc.)",
    otherLimited:
        "In other cases, please limit to less than 1000 words (after accidental deletion, undo the operation by pressing Ctrl+z).",
    designRequirement:
        "Design requirements of the previous stage (for any change, ask the doctor to adjust the design requirements in time; if not, the company will follow the design requirements of the previous stage)",
    NonRemovableTeeth: "Non-removable teeth",
    NonRemovableTeethType:
        "(Like porcelain, crown bridge, implanted and others)",
    followingTeethImmovable: "The following teeth are immovable",
    notDesigned: "Teeth with no Attachment",
    notDesignedType:
        "Like porcelain, crown bridge and others.",
    NonRemovableDesign:
        "No attachment for following teeth",
    FlatGuidePlateTeeth: "Flat guide plate of anterior teeth",
    suitableCase: "Suitable for cases of Deep Overbite superficial coverage",
    suitableCase2: "shallow over jet cases",
    anteriorCentralIncisor: "Central incisor of anterior teeth",
    LateralIncisorsAnteriorTeeth: "Lateral incisor of anterior teeth",
    anteriorTeeth2: "anteriorTeeth2",
    longDistanceTreatment: "Is the remote correction adopted",
    selectYes: "Note",
    yes: "Yes",
    no: "No",
    cover: "Overjet",
    every3mothsVisit: "Re-visit every 3 months",
    every6mothsVisit: "Re-visit every 6 months",
    every12mothsVisit: "Re-visit every 12 months",
    secondVisit: "Second visit",
    unableDetermineReferralPeriod: "Unable to determine the re-visit period",
    followUpOrthodontic:
        "Follow-up orthodontic treatment requirements (initial orthodontic treatment objectives should not be changed)",
    limited: "Please enter less than 1000 words",
    unfitPhotographs: "Photos of unfit parts of aligner",
    unfit: "Unfit",
    images: "Images",
    photographs: "Intraoral photos",
    photoface: "Face photos",
    xphoto: "X-Rays",
    wholeJaw: "Whole jaw",
    cephalometric: "Lateral cephalometric radiograph",
    submitDataModel: "Please submit a complete and clear digital model",
    viewingModelRequirements: "View model requirements",
    boxScanFile: "Box scanning files",
    saveSTL: "Save as STL format;",
    scanList: "The occlusion scanning record must be included",
    save: "click save / saved",
    doctorSignature: "Doctor's signature",
    date: "Date",
    completionOrthodonticTreatment:
        "Completion status of orthodontic treatment",
    whichBelongs: "Determine the completion status",
    achievingCorrectionObjectives: "Correction objectives achieved",
    changeOtherMethods:
        "The invisible correction achieves the stage effects and is completed by other correction methods",
    unfinishIquiredOver:
        "The objective of correction is not achieved, but the patient asks to terminate the correction",
    inputOthers: "Please fill in the other reasons in the input box",
    finishedPhotos: "Photos of finished correction",
    postWarrantyData: "Retainer data",
    letterAuthorization: "Letter of consent",
    currentPatientName: "Current patient name",
    hospital: "Hospital",
    clinic: "Clinic",
    letterSmartee:
        "Agree to the Invisible Orthodontic Treatment Termination Agreement",
    letterPrint:
        "Print the Invisible Orthodontic Treatment Termination Agreement",
    canvasDesign: "Animation design",
    canvasView: "Animation view",
    gums: "Gums",
    workSpace: "Working surface",
    contrast: "Contrast",
    occlusion: "Occlusion",
    enclosure: "Enclosure",
    grid: "Grid",
    designCommunication: "Design communication",
    distributionInformation: "Distribution information",
    operation: "Operation instructions",
    inputEdit: "Please enter your suggestions on revision here",
    agreeProgramme:
        "Please agree to the orthodontic treatment programme by the approval button in the upper right corner",
    mockProgramme: "Simulation programme",
    effectDifferent: "The actual therapeutic effects may be different",
    animationContrast: "Animation contrast",
    transferCases: "Save and transfer new cases",
    scanRescan: "Smartee intraoral scanning, re-scan",
    mk: "MK",
    mainPages: "Main interface",
    UnderTenyears: "Under 10 years old",
    from10to20: "From 10 to 20",
    from21to30: "From 21 to 30",
    from31to40: "From 31 to 40",
    over41: "Over 41",
    interproximalEnamelStripping: "IPR",
    distalMolars: "Molar distalization",
    classTraction: "Class II/III traction",
    extendedAnteriorTeeth: "Extend anterior teeth",
    lowerFrontTeeth: "Lower anterior teeth",
    archExpansion: "Arch expansion",
    pressDown: "Lower the anterior teeth and lift the anterior molars",
    lipMoveUp: "Extrude upper anterior",
    tongueMovedown: "Linguoversion of mandibular anterior teeth",
    maxillaryAnteriorTeeth: "Extend the maxillary anterior teeth",
    mandibleAnteriorTeeth: "Extend the mandible anterior teeth",
    improveMidline: "Improve midline",
    midline: "Midline",
    improvementMaxillaryProtrusion: "Improve the maxillary protrusion",
    improvementMaxillaryRetraction: "Improve the maxillary retraction",
    improvementMandibularProtrusion: "Improve the mandibular protrusion",
    improvingMandibularRetraction: "Improve the mandibular retraction",
    sagittalRelationship: "Sagittal relationship",
    allJawSilicone:
        "The both arch silicone rubber impressions or STL scans is always required even if just for a single arch treatment.",
    improve: "Improve",
    maintain: "Maintain",
    firstChoice: "First choice",
    overlay: "over bite",
    optional: "Optional",
    notAllowed: "Not allowed",
    rightUpper: "Right upper",
    leftUpper: "Left upper",
    xRayRequired: "Note",
    maintainingImprovingRelationship:
        "Maintain and improve the relationship between teeth",
    caninesMolars: "Improve the relationship between canines and molars",
    caninesfangs: " improving canine relationship only",
    adjustmentNeutrality: "Adjust to the neutrality relationship",
    moreAdjacentGlazing:
        "Any more IPR or Extraction maybe required",
    maintainMidline: "Maintain ( IPR if necessary )",
    maybeRequerEnamelStripping:
        "(Interproximal enamel stripping may be required)",
    lefttoPatient: "Adjust to patient's left",
    correctionGap: "Correction for Spacing",
    increaseDesigns:
        "Which may leads to more modifications for 3D animation designing",
    righttoPatient: "Adjust to patient's right",
    noSpaceReserved: "No space left",
    spaceReserved: "Leave rest of space at:",
    adduction: "Adduction of anterior teeth",
    NearPosteriorTooth: "movement towards medial surface of posterior teeth",
    adductionNearPosteriorTooth:
        "Adduction of anterior teeth and movement towards medial surface of posterior teeth",
    lipTilt: "Proclination",
    toothExtraction: "Tooth extraction",
    notoothExtraction: "No tooth extraction",
    correctionCrowding: "Correction for Crowing",
    followingTeeth: "Extract the following teeth",
    methods: "Correction method",
    intermaxillaryTraction:
        "It is necessary to cooperate with intermaxillary traction",
    caseBank: "Case bank",
    marketActivity: "Market activity",
    messageNotification: "Message notification",
    messageDetail: "Message details",
    wornOut: "The aligners are about to be worn out",
    canvasModified: "Animation programme modified",
    fixedTel: "Landline",
    definition3Ddesign: "Comfirm after 3D Animation designed",
    othersSpecified: "Others (specify in the special instructions)",
    openOcclusion: "Correct Open Bite",
    deepOverbite: "Deep Overbite",
    overbite: "Overbite",
    backtop: "Back to top",
    onlyanteriorTeeth: " lowering anterior teeth only",
    receiveName: "Recipient",
    region: "Region",
    addressDetail: "Detailed address",
    telphone: "Contact information",
    default: "Default",
    invoiceAddress: "Invoice mailing address",
    loginPassword: "Login password",
    verifyphone: "Verify phone",
    anteriorTeeth: "Anterior Edge to Edge Occlusion",
    anteriorCrossbite: "Anterior teeth under bite",
    posteriorTeeth: "Crossbite or locked occlusion of posterior teeth (if any)",
    posteriorTeeth2: "Or louck",
    exist: "if any",
    addSubaccounts: "Add a subaccount",
    editSubaccounts: "edit the subaccount",
    subaccountName: "Subaccount username",
    subaccountPassword: "subaccount password",
    shippingaddress: "Receiver address",
    access: "Access permission",
    availability: "Availability",
    notRectify: "Maintain",
    correct: "correcting",
    rectify: "Rectify",
    designValidation:
        "Design validation, design sharing and submission of communication opinions",
    editcase:
        "Edit the case submission form, confirm receipt and end treatment",
    sheetView: "View quotation",
    maybe: "Is it ok",
    specialInstructions: "Special Notes",
    wisdomTooth: "Wisdom tooth",
    defaultRemoval: "Extraction by default (not covered by the aligner)",
    requirements: "Based on the requirements of the programme",
    glazeRemoval: "Glaze removal",
    glazeRemovalPositon: "Glaze removal position",
    frontTeethFirst: "Anterior teeth first",
    posteriorTeethPreferred: "Posterior teeth first",
    beautifulDentition: "Beautiful dentition",
    unwanted: "Not required",
    need: "Required when the anterior interdental space is greater than 4 mm",
    attachment: "Operation and attachment paste",
    doing: "Proceed",
    DelayStep: "Postponed to",
    systemhelp: "System help",
    tips: "Tips",
    consultation:
        "You haven't installed Smartee intraoral scanning software yet.Please contact your customer service or sales personnel for consultation!",
    feeConfirmationForm:
        "Fee Confirmation of Smartee Invisible Orthodontic Treatment without bracket",
    back: "Back",
    specificationTable: "Specification table",
    confirmationAgreement: "Confirmation agreement",
    scanApp:
        "Scan and download Smartee Invisible Orthodontic Treatment Mobile App",
    semail: "Email sent",
    fineTuned: "Aligner in processing",
    followTitle: "Subsequent processing",
    deliveryTotal: "Delivery phase",
    total: "Case statistics",
    this: "This application",
    deliveryTime: "Expected next delivery application time",
    fineTunedCases: "Fine-tuned cases",
    submitted: "Submitted",
    clickUpload: "Click to modify",
    secret: "Confidentiality",
    edit: "Edit",
    add: "Add",
    isDefault: "Is default",
    zhengyakousweepdata: "Smartee intraoral scanning file",
    requiredPhone: "Mobile phone number cannot be empty",
    requiredPhone11:
        "Mobile phone number should be at least 11 characters long",
    requiredRightPhone: "Please enter a correct mobile phone number!",
    requiredPassword: "Password code cannot be empty",
    requiredPasswordLg6: "Password should be at least 6 characters long",
    requiredCode: "Verification code cannot be empty",
    requiredCodelg6: "Verification code should be at most 6 characters long",
    errorSubmit: "Submission error!",
    sendSuccess: "Sent successfully! Enclosed please find",
    sendError: "Sending error! Please send again",
    resetPassword: "Reset password",
    requiredEmail: "Please enter a correct email address",
    choose: "Please choose",
    introduction: "Profile",
    baseInfo: "Basic information",
    city: "City",
    oldPassword: "Old password",
    newPassword: "New password",
    changeSuccess: "Modified successfully",
    checkPass: "Confirm password",
    oldphone: "Old mobile phone number",
    newphone: "New mobile phone number",
    Name: "First name",
    editRow: "Operate",
    addInvoiceAddress: "Add the invoice mailing address",
    addAddress: "Add the receiving address",
    editInvoiceAddress: "Modify the invoice mailing address",
    editAddress: "Modify the receiving address",
    inputHospitalName: "Please enter the hospital name",
    inputHospitalAddress: "Please enter the hospital name",
    casesn: "ID",
    casecode: "Number",
    age: "Age",
    rightdown: "Lower right",
    leftdown: "Lower left",
    over2m: "Above 2mm",
    isrequerdtosmartee:
        "Will you go detailed online communication and modification with us when designing the 3D Treatment Plan?",
    isMSGRead: "Read",
    isMSGunRead: "Unread",
    sysNotise: "System reminder",
    processNotise: "Progress reminder",
    stepsNotise: "Phase reminder",
    patientGender: "Please choose the gender",
    inputpatientAge: "Please enter the age",
    isCase: "Case management",
    isDesign: "designing management",
    isTreat: "treatment management",
    isFinance: "Financial rights",
    isCasedes:
        "case management--adding new cases,one - pressing scanning system",
    isDesigndes:
        "designing management-designing confirming, designing discussion, suggestion submission",
    isTreatdes:
        "treatment management--patient form editing, goods confirming, treatment finished",
    isFinancedes: "finance management--quotation checking",
    onlyready: "Read only",
    designData: "designing data",
    trackItems: "logistics information/ tracking information",
    inputSearch: "input patient name, ID, case number",
    doctor: "doctor",
    personalCenter: "  personal center",
    home: "home page",
    logout: "Log out",
    noOperation: "no clinical operation recently",
    otherPhotos1: "others",
    otherPhotos2: "others",
    shaporironasweep: "3 Shape / Sirona Scanning system",
    userAgreementTitle: "Smartee user agreement",
    userAgreementAlert: "Key Tips",
    userAgreementDes:
        'before submitting cases and using other functions through Smartee Case Management System(hereinafter to be refered as "System") of Shanghai Smartee Denti- Technology co., Ltd. (hereinafter to be referred as "Smartee"), please be sure to carefully read and fully understand the contents of the terms of this agreement, including but not limited to the terms of exemption or limitation of liability. If you do not agree to this agreement and/or its modification from time to time, you may take the initiative to stop using the services provided by Smartee; Once you use the service, you will be deemed to have understood and fully agreed to the content of this agreement, including any modification made by Smartee to the service agreement at any time, and become a user of Smartee.',
    userAgreement100: "summary",
    userAgreement110:
        "User shall agree to the terms of this agreement and complete all registration procedures as indicated on the page. By clicking the agree button during the registration process, user has reached an agreement with Smartee and fully accepted all the terms and conditions hereunder.",
    userAgreement120:
        "After registration, the account and password shall be kept by user. Users shall be responsible to all activities and events performed under their accounts.",
    userAgreement200: "Registration information and privacy protection",
    userAgreement210:
        "The Smartee system account and ownership of all virtual goods in the account belong to Smartee. you can become Smartee user by filling in the information according to the registration page, reading and agreeing to this agreement and completing all the registration procedures. Users should provide timely, detailed and accurate personal information, and constantly update the registration information which meet the requirements of timely, detailed and accurate. All data originally inputted will be referenced as registration data. If the registration information is not true or the update is not timely, we will not be responsible for any related problems.The user shall register the account with real identity information, and the account name、profile picture、profile and other registration information submitted by user shall not contain illegal or bad information. At the same time, if users is found after registration that they obtain the account name for registration by false information, or the account profile picture, profile and other registration information of the user is found to have illegal or bad information, Smartee has the right to unilaterally take measures such as modifying by user within a time limit, suspension of use, cancellation of registration and withdrawal without notice.",
    userAgreement220:
        "After registration process and becoming the official user of Smartee, users shall be entitled to all rights prescribed by Smartee; Smartee also has the right to change the permissions of its official users.",
    userAgreement230:
        "The following contents shall not be used as the account name when users register. If users accounts are found to contain indecent words or inappropriate names, Smartee reserves the right to cancel their user qualification.",
    userAgreement231:
        "Register with the real name, trade name, stage name or pen name of party and state leaders or other social celebrities.",
    userAgreement232:
        "Register with the name of a national institution or other institutions.",
    userAgreement233:
        "Register with an uncivilized or unhealthy name, or a term that contains discrimination, insult, or obscenity.",
    userAgreement234:
        "Register with words that are easy to produce ambiguity, cause others to misunderstand or other words that do not comply with laws and regulations, rules and regulations, etc.",
    userAgreement240:
        "In addition to the terms of service provided by Smartee, we shall not be liable for any accident, negligence, contract destruction, defamation, infringement of copyright or other intellectual property rights or any loss arising out of the use of this services.",
    userAgreement250:
        "User shall be responsible for keeping the account and password of this system, and shall take full responsibility for all activities under the account and password. Users shall pay attention to the password protection of account, password and public mailbox. User shall not transfer, sell or lend his/her account number and password to others. If user authorizes others to use the account, he/she shall be fully responsible for all the behaviors of the authorized person under the account. Smartee is unable to find out illegal or unauthorized use of your account and password, so Smartee does not assume any responsibility.",
    userAgreement260:
        "If you do not use your account for 12 consecutive months or do not log in your account by other means approved by Smartee after registration, Smartee has the right to withdraw your account to avoid resource waste, and the loss caused thereby shall be borne by you. In line with the purpose of effectively using Smartee resources and protecting more legitimate users rights and interests, Smartee has the right to withdraw those who maliciously register or have not logged into the system account for a long time.",
    userAgreement300: "Service items",
    userAgreement310:
        "The specific content of this service system is provided by Smartee according to the actual situation",
    userAgreement320:
        "Unless other provisions, the new functions and services provided by Smartee shall be governed by this agreement.",
    userAgreement330:
        "Except with Smartees consent, user shall not copy, sell, resell or use any part of the service or the acquisition of the service for any other commercial purposes.",
    userAgreement340:
        "In order to use the service, you must have access to the Internet by a third party that is legally qualified to provide services and pay for the services at your own expense. In addition, you must be equipped with and responsible for all necessary equipment for connecting to the international network, including computer data machines or other access devices.",
    userAgreement350:
        "In view of the particularity of the network services, users agree that Smartee has the right to change, interrupt or terminate part or all of the network services (including the paid network services) at any time without prior notice. Smartee does not guarantee that network services will not be interrupted, nor does it guarantee the timeliness, security and accuracy of network services.",
    userAgreement360:
        "Smartee reserves the right to temporarily or permanently modify or terminate the service (or any part thereof) at any time without any liability to the user or any third party, whether notified or not.",
    userAgreement400: "accountability system",
    userAgreement410:
        "You agree to indemnify and hold Smartee harmless from any claims, demands or losses claimed by any third party, including attorney's fees, arising out of user's violation of this agreement or the relevant terms of service. In this regard, Smartee has the right, depending on the nature of the user's behavior, to take measures including but not limited to the deletion of the user's published information content, suspension of the license, termination of the service, restriction of use, recovery of its account, and investigation of legal responsibility. Smartee shall have the right to withdraw their accounts for malicious registration or illegal activities, disturbance、harassment, deception on other users and other ACTS violating this agreement.",
    userAgreement420:
        "Users shall be responsible to their actions when using this system. The forms of the user's legal liability include but are not limited to: compensation for the aggrieved, and pay the equal amount compensation to Smartee when Smartee first undertaking the administrative penalty or the liability for tort damage caused by user.",
    userAgreement500: "other items",
    userAgreement510:
        "The conclusion, performance, interpretation of this agreement and the settlement of disputes shall be governed by the laws of the People's Republic of China.",
    userAgreement520:
        "Any dispute arising from or in connection with this agreement shall be settled by the parties through friendly consultation. If no agreement can be reached through negotiation, both parties agree to file a lawsuit with the people's court of Pudong New District in Shanghai for settlement.",
    userAgreement530:
        "If any provision of this agreement is wholly or partially invalid or unenforceable for any reason, the remaining provisions of this agreement shall remain valid and binding.",
    userAgreement540:
        "For orders submitted by System, it will assume that the customer has received the goods by default if system has not received the goods confirmation starting from the 15th day after delivery.",
    incompleteprompt:
        "You still have the following items to fill in, please go ahead and then submit ",
    confirmcompleted:
        "The following case information has been filled in, please confirm and submit",
    suitablecases: "suitable for Deep Overbite and overjet cases.",
    Zhongtong: "ZTO",
    Yuantong: "YTO",
    SFExpress: "SF Express",
    Shentong: "STO",
    best: "Best Express",
    postal: "EMS",
    daily: "TTK",
    yunda: "Yunda",
    homedelivery: "ZJS",
    speedlogistics: "UCE",
    fullPeak: "Quanfeng Express",
    storagesuccess: "Save Successfully",
    helpdocument: "Help document",
    videofile: "Video file",
    confirmDelete: "Confirmdelete?",
    nonconformitynotice: "Non-conformity notice",
    deliverytimeforthisphase: "Estimated delivery time for this phase:",
    changeaddress:
        "If you need to change the delivery address, please contact customer service!",
    Thenumberofstepsinthisshipment: "The number of steps in this shipment",
    Totaldeliveryphase: "Total delivery phase",
    Times: "Times",
    First: "First",
    this: "This application",
    Medicalinstitutions: "Medical institutions",
    tipes:
        "The number of upper and lower jaw steps cannot be 0 at the same time",
    imagesfirsttip: "Upload photos in bulk, and double-click to delete",
    imageslasttip:
        "Drag photos to left corresponding positions after uploading",
    toothtipe:
        "Note: Red for deciduous teeth, Gray for missing teeth",
    Resend: "Resend",
    ResendCode: "Resend Code",
    tipsMessage: "Viewing old cases from 2010.01.11 into V2.0 system",
    pagefooterTips:
        "Customer Service Phone: 021-50798880 E-Mail: case@smartee.cn",
    pagefooterTips1:
        "Address: 2nd Floor, Room 122, No. 2305, Zuchongzhi Road, China (Shanghai) Pilot Free Trade Zone, Shanghai ICP No. 12307358-1 / Hugong Net Security 156802014685 / Powered by © 2015-2018 SMARTEE.CN",
    Startportsweep: "Start port sweep",
    Viewmouthsweep: "View mouth sweep",
    Pleaseinformation: "Please upload file information",
    entersteps: "Please fill in the number of steps",
    NetworkError: "Network Error",
    Missingupperjaw: "Missing upper jaw",
    Missingjaw: "Missing jaw",
    Missingupperandlowerjaw: "Missing upper and lower jaw",
    canceledoperation: "You have canceled the operation",
    notinstalled:
        "The port scan software is not installed or the installation path is incorre",
    Nomouthscanfile: "No mouth scan file",
    Comingsoontonewcases: "Coming soon to new cases",
    Failed: "Failed",
    isloading: "Loading",
    filetyps: 'Upload as a compressed package (the file type must be .rar/.zip)'

};



// WEBPACK FOOTER //
// ./src/lang/en.js